export const BOARD_ENTRY_FROM = {
  CLASSROOM: 'classroom',
  MY_BOARD: 'my_board',
  MY_BOARD_MODAL: 'my_board_modal',
} as const;

export type BoardEntryFrom =
  (typeof BOARD_ENTRY_FROM)[keyof typeof BOARD_ENTRY_FROM];

type BoardEnterEventFrom =
  | 'classroom'
  | 'direct_url'
  | 'my_board_page'
  | 'my_board_modal';

const BOARD_ENTER_EVENT_FROM_MAP = {
  [BOARD_ENTRY_FROM.CLASSROOM]: 'classroom',
  [BOARD_ENTRY_FROM.MY_BOARD]: 'my_board_page',
  // 내 콘텐츠(내 보드) 모달의 "입장" 클릭.
  [BOARD_ENTRY_FROM.MY_BOARD_MODAL]: 'my_board_modal',
} as const satisfies Record<BoardEntryFrom, BoardEnterEventFrom>;

export function getBoardPath(
  boardId: string,
  options?: { from?: BoardEntryFrom; settings?: boolean },
): string {
  const params = new URLSearchParams();
  if (options?.from) params.set('from', options.from);
  // 생성 직후 진입처럼 설정 패널을 연 채로 시작해야 하는 경우에만 붙인다.
  if (options?.settings) params.set('settings', 'true');

  const query = params.toString();
  return query ? `/board/${boardId}?${query}` : `/board/${boardId}`;
}

export function getBoardEnterEventFrom(
  from: string | string[] | undefined,
): BoardEnterEventFrom {
  const normalizedFrom = Array.isArray(from) ? from[0] : from;

  if (normalizedFrom && normalizedFrom in BOARD_ENTER_EVENT_FROM_MAP) {
    return BOARD_ENTER_EVENT_FROM_MAP[normalizedFrom as BoardEntryFrom];
  }

  return 'direct_url';
}
